import { FC } from 'react'

export const TourtipArrowIcon: FC = () => {
  return (
    <svg width='16' height='7' viewBox='0 0 16 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.13511 3.13511C5.04057 5.04057 5.99331 5.99331 7.12743 6.24681C7.70205 6.37526 8.29795 6.37526 8.87257 6.24681C10.0067 5.99331 10.9594 5.04057 12.8649 3.1351L16 0H0L3.13511 3.13511Z'
        fill='var(--surface-inverse-white-neutral)'
      />
    </svg>
  )
}
